<template>
    <div class="animated fadeIn">
        <DynamicForm
                v-model="dataId"
                ref="dynamicForm"
                getRoot="/branch"
                saveRoot="/branch"
                @onTrashClick="onTrashClick"
                :formStructure="dataFormStructures.branch">
        </DynamicForm>
        <ModalTrash
                ref="trash"
                root="/branch"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression de l\'établissement')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cet établissement?')"></ModalTrash>
    </div>
</template>

<script>
    import DynamicForm from '../components/DynamicForm'
    import ModalTrash from '../components/ModalTrash'
    export default {
        name: 'Branch',
        components: {
            DynamicForm,
            ModalTrash
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataId: '',
                dataFormStructures: {
                    branch: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Établissement'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'name'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Coordonnées'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'address'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'country'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'province'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'city'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'zipcode'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'phone'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'email'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'domain'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'subDomain'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'shortDescription'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'image'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'name',
                                type: 'text',
                                label: Core.Definition.getDefinition('Nom'),
                            },
                            {
                                id: 'phone',
                                type: 'phone',
                                label: Core.Definition.getDefinition('Téléphone'),
                            },
                            {
                                id: 'email',
                                type: 'text',
                                label: Core.Definition.getDefinition('Courriel'),
                            },
                            {
                                id: 'subDomain',
                                type: 'text',
                                label: Core.Definition.getDefinition('Sous-domaine'),
                                required:true
                            },
                            {
                                id: 'domain',
                                type: 'text',
                                label: Core.Definition.getDefinition('Domaine'),
                                required:true
                            },
                            {
                                id: 'address',
                                type: 'text',
                                label: Core.Definition.getDefinition('Adresse'),
                            },
                            {
                                id: 'country',
                                type: 'country',
                                label: Core.Definition.getDefinition('Pays'),
                                required: false,
                                value: {value: 'CA', label :'Canada'},
                                onSelect: function(value, form, fieldRefs) {
                                    if (value !== null && value.value !== undefined) {
                                        fieldRefs['province'].retrieve(value.value)
                                    } else {
                                        fieldRefs['province'].dataValue = null
                                    }
                                }
                            },
                            {
                                id: 'province',
                                type: 'province',
                                value: {value: 'QC', label :'Quebec'},
                                label: Core.Definition.getDefinition('Province'),
                                required: false,
                                onSelect: function() {}
                            },
                            {
                                id: 'city',
                                type: 'text',
                                label: Core.Definition.getDefinition('Ville'),
                            },
                            {
                                id: 'zipcode',
                                type: 'text',
                                label: Core.Definition.getDefinition('Code Postal'),
                            },
                            {
                                id: 'shortDescription',
                                type: 'editor',
                                label: Core.Definition.getDefinition('Description'),
                                value: '',
                                sortable: true
                            },
                            {
                                id: 'image',
                                placeholder: Core.Definition.getDefinition('Téléversez une image à la une'),
                                type: 'image',
                                label: Core.Definition.getDefinition('Image'),
                                value: [],
                                thumbnailWidth: 500,
                                maxFilesize: 5
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onTrashClick(id) {
                this.$refs.trash.open(id)
            },
            onTrashSuccess() {
                this.$router.push('/systeme/etablissements')
            }
        }
    }
</script>
